import { StackProps } from '@chakra-ui/react';
import React from 'react';

import { HStack, Text, VStack } from '../../../core-ui';

type Props = StackProps & {
  content: string;
  createdAt: string;
  username?: string;
};

export function SalesNote(props: Props) {
  const { content, createdAt, username, ...stackProps } = props;

  return (
    <VStack {...stackProps}>
      <SalesNoteHeader date={createdAt} username={username} />
      <Text borderRadius="10px" p={2} backgroundColor="#f2f2f2" width="100%">
        {content}
      </Text>
    </VStack>
  );
}

type SalesNoteHeaderProps = {
  username?: string;
  date: string;
};

function SalesNoteHeader(props: SalesNoteHeaderProps) {
  const { date, username } = props;
  return (
    <HStack width="100%">
      <VStack>
        <Text width="100%">{username ?? t('User not found')}</Text>
        <Text width="100%">{date.split('T')[0]}</Text>
      </VStack>
    </HStack>
  );
}
